import { createFileRoute } from '@tanstack/react-router';

import { EntriesPage } from '@/features/collections';
import { workspaceSearchSchema } from '@/patterns';
import { currentPeriod } from '@/shared/lib/dates';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/collections/adjustments')({
  validateSearch: workspaceSearchSchema.extend({ new: zSearchText() }),
  staticData: { crumb: 'collections:nav.adjustments' },
  component: function CollectionsList() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    const onSearchChange = (patch: Record<string, unknown>, o?: { replace?: boolean }) =>
      void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: o?.replace ?? false });
    return (
      <EntriesPage
        kind="adjustment"
        search={search}
        period={search.period ?? currentPeriod()}
        bank={search.bank}
        onScopeChange={(patch) => onSearchChange({ ...patch, page: undefined })}
        onSearchChange={onSearchChange}
      />
    );
  },
});
